import {
  CreateEditPrivateLocationRequest,
  CreateEditPublicLocationRequest,
  PrivateLocationRequest,
  PublicLocationRequest,
} from '../../../core/domain/requests';
import { GetSegmentSuggestionsRequest, Location, Product } from '../../../core/domain/models';
import { AppliedFilters } from '../../../core/domain/models/applied-filter.model';

export class PublicLocations {
  static readonly type = '[Locations] Get Public Locations';

  constructor(public payload: PublicLocationRequest | undefined) { }
}

export class AddPublicLocation {
  static readonly type = '[Locations] Add Public Location';

  constructor(public payload: CreateEditPublicLocationRequest | undefined) { }
}
export class SetPublicLocationId {
  static readonly type = '[Locations] Set Public Location ID';
  constructor(public publicLocationId: string) { }
}
export class GetPrivateLocations {
  static readonly type = '[Locations] Get Private Locations';

  constructor(public payload: PrivateLocationRequest | undefined) { }
}

export class SetPrivateLocations {
  static readonly type = '[Locations] Set Private Locations';

  constructor(public payload: Location[] | undefined) { }
}

export class GetDawaAutoCompleteLocations {
  static readonly type = '[Locations] Get Dawa AutoComplete Locations';

  constructor(public payload: string | undefined) { }
}

export class GetGLSLocations {
  static readonly type = '[Locations] Get GLS Locations';

  constructor(public payload: string | undefined) { }
}

export class SetIsAddressLocationLoading {
  static readonly type = '[Locations] Set Address Location Loading';

  constructor(public payload: boolean | undefined) { }
}

export class GetPrivateLocationById {
  static readonly type = '[Locations] Get private location by id';

  constructor(public payload: string | undefined | null) { }
}

export class SetSelectedLocation {
  static readonly type = '[Locations] Set Selected Location';

  constructor(public payload: Location | undefined) { }
}

export class SetProducts {
  static readonly type = '[Products] Set Selected Location';

  constructor(public payload: Product[] | undefined) { }
}

export class CreateLocation {
  static readonly type = '[Locations] Create New Location';

  constructor(public payload: CreateEditPrivateLocationRequest) { }
}

export class EditLocation {
  static readonly type = '[Locations] Edit Location';

  constructor(public payload: CreateEditPrivateLocationRequest) { }
}

export class DeleteLocation {
  static readonly type = '[Locations] Delete Public Location';

  constructor(public payload: string) { }
}

export class DeactivateLocation {
  static readonly type = '[Locations] Deactivate Public Location';

  constructor(public payload: string) { }
}

export class GetProducts {
  static readonly type = '[Locations] Get Products';
}

export class ClearProducts {
  static readonly type = '[Locations] Clear Products';
}

export class GetProductActivities {
  static readonly type = '[Locations] Get Product Activities';

  constructor(public payload: string | undefined) { }
}

export class GetLocationTypes {
  static readonly type = '[Locations] Get Location Types';
}

export class ClearLocationTypes {
  static readonly type = '[Locations] Clear Location Types';
}

export class IsProductShown {
  static readonly type = '[Locations] Is Product Shown';

  constructor(public payload: boolean | undefined) { }
}

export class IsLocationDetailShow {
  static readonly type = '[NewEditMasterPlan] Is Location Detail Show';

  constructor(public payload: boolean | undefined) { }
}

export class ImportLocationsFromFile {
  static readonly type = '[ImportLocationsFromFile] upload excel file.';

  constructor(public payload: FormData) { }
}

export class GetLocationsImportSampleFile {
  static readonly type =
    '[GetLocationsImportSampleFile] download excel import sample file.';

  constructor(public payload: boolean | undefined) { }
}

export class IsSegmentUpdateForProducts {
  static readonly type = '[Locations] Is Segment update for products.';

  constructor(public payload: boolean | undefined) { }
}
export class GetSegmentSuggestions {
  static readonly type = '[GetSegmentSuggestions] get nearest segment ids for suggestion';

  constructor(public payload: GetSegmentSuggestionsRequest) { }
}
export class IsProductsSave {
  static readonly type = '[Locations] Is Products Save.';

  constructor(public payload: boolean | undefined) { }
}
export class IsSubLocationSaved {
  static readonly type = '[Locations] Is SubLocation Saved.';

  constructor(public payload: boolean | undefined) { }
}

export class IsLocationInfoSaved {
  static readonly type = '[Locations] Is LocationInfo Saved.';

  constructor(public payload: boolean | undefined) { }
}
export class ReSetSubLocations {
  static readonly type = '[Locations] ReSet Sub Locations.';

  constructor(public payload: boolean | undefined) { }
}
export class ReSetProducts {
  static readonly type = '[Locations] ReSet Products.';

  constructor(public payload: boolean | undefined) { }
}
export class ReSetLocationInfo {
  static readonly type = '[Locations] ReSet Location Info.';

  constructor(public payload: boolean | undefined) { }
}

export class GetSortingOptions {
  static readonly type = '[Locations] Get Sorting Options';
}

export class SetAppliedFilters {
  static readonly type = '[Locations] Set applied filters for locations'

  constructor(public payload: AppliedFilters[] | undefined) { }
}

export class SetFilters {
  static readonly type = '[Locations] Set filters selected by the customer'

  constructor(public payload: any[] | undefined) { }
}

export class SetFilterRequest {
  static readonly type = '[Locations] Set requested filters selected by the customer'

  constructor(public payload: any | undefined) { }
}

export class SetAppliedSortings {
  static readonly type = '[Locations] Set sort filters selected by the customer'

  constructor(public payload: any | undefined) { }
}

export class GetCountries {
  static readonly type = '[Locations] Get Countries Data'

  constructor(public payload: any | undefined) { }
}

export class IsSidebarToggled {
  static readonly type = '[Locations] Is Sidebar Collapsed';

  constructor(public payload: boolean | undefined) { }
}